import { sectionBorders, SectionDivider } from '../or-flexible-block/index.components'

export interface SimpleText {
  title: string
  subtitle: string
}

export interface OrSimpleTextBlockProps {
  mainTitle: string
  mainSubtitle: string
  contents: SimpleText[]
}

export const OrSimpleTextBlock = ({ mainTitle, mainSubtitle, contents }: OrSimpleTextBlockProps) => (
  <>
    <SectionDivider />
    <section className={sectionBorders}>
      <div className="flex flex-col items-start lg:w-[44.3rem]">
        <h2
          data-simple-text-block-title
          className="text-neutrals-900 font-medium mb-4 lg:mb-6 text-32 font-heading leading-1.3"
        >
          {mainTitle}
        </h2>
        <p data-simple-text-block-subtitle className="text-neutrals-800 text-14 lg:text-16 leading-1.5">
          {mainSubtitle}
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-7.5 mt-10">
        {contents.map((content, index) => (
          <div data-simple-text-block-item key={index} className="flex flex-col items-start">
            <h3 data-simple-text-block-title className="text-neutrals-800 font-bold mb-2 text-16 leading-1.3">
              {content?.title}
            </h3>
            <p data-simple-text-block-subtitle className="text-neutrals-800 mb-6 text-14 leading-1.5">
              {content?.subtitle}
            </p>
            <div className={`${index === contents.length - 1 ? '' : 'mb-12'}`}>
              <div className="h-0.5 w-12 bg-secondary-700" />
            </div>
          </div>
        ))}
      </div>
    </section>
  </>
)
